import { NbMenuItem } from "@nebular/theme"

export enum MenuItemType {
  DEFAULT = "DEFAULT",
  IMAGE_HEADER = "IMAGE_HEADER",
  DROPDOWN = "DROPDOWN",
  GROUP = "GROUP",
  NAME = "NAME",
  AGE = "AGE",
  WHATSAPP_MAIL= "WHATSAPP_MAIL"
}

export declare class FeatureMenuItem extends NbMenuItem {
  public type: MenuItemType;
  public exta?: Array<{ key: string, value: string }>
  public class?: string;
  public consultationRequired?: boolean;
  public extra?: any[];
}
